'use strict';
define([],function(){
    return {
        templateUrl: 'app/modules/leadgeneration/components/leadgeneration-add-box/leadgeneration-add-box.html',
        bindings: {  },
        controller:['$scope',function($scope){

        }]
    };
});